import { Routes, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { OnboardingCompletedGuard } from './router/guards/onboarding-completed.guard';
import { OnboardingNotCompletedGuard } from './router/guards/onboarding-not-completed.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./components/pages/navigation-tabs/navigation-tabs.routes').then(
        (m) => m.routes,
      ),
    canActivate: mapToCanActivate([MsalGuard, OnboardingCompletedGuard]),
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./components/pages/notification/notification.page').then(
        (m) => m.NotificationPage,
      ),
    canActivate: mapToCanActivate([MsalGuard, OnboardingCompletedGuard]),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./components/pages/onboarding/onboarding.routes').then(
        (m) => m.routes,
      ),
    canActivate: mapToCanActivate([MsalGuard, OnboardingNotCompletedGuard]),
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./components/pages/welcome/welcome.page').then(
        (m) => m.WelcomePage,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth',
  },
];
